import React from "react";

import Main from "../layouts/Main";

import { ContactForm, ContactInfo } from "../components/ContactUs";
import PageBanner from "../components/PageBanner";

const ContactUs = () => (
  <Main>
    <PageBanner title="Contact Us" />
    <section className="ls s-py-60 s-py-md-90 s-py-xl-120">
      <div className="container">
        <div className="row">
          <ContactForm />
          <ContactInfo />
        </div>
      </div>
    </section>
  </Main>
);

export default ContactUs;
